import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const SubscriptionPlans = ({ plans, currentPlanId, onUpgrade }) => {
  const currentPlan = plans?.find(p => p?.id === currentPlanId);

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
      {plans?.map((plan) => {
        const isCurrent = plan?.id === currentPlanId;
        const isUpgrade = plan?.tier > (currentPlan?.tier ?? 0);

        return (
          <div
            key={plan?.id}
            className="card relative"
            style={{
              borderColor: isCurrent ? 'var(--color-primary)' : plan?.isPopular && !isCurrent ? 'rgba(255,87,34,0.3)' : undefined,
              borderWidth: isCurrent || (plan?.isPopular && !isCurrent) ? '2px' : undefined,
              overflow: 'hidden',
              transition: 'transform 200ms cubic-bezier(0.22,1,0.36,1), box-shadow 200ms ease-out',
            }}
            onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-5px)'; e.currentTarget.style.boxShadow = '0 14px 36px rgba(0,0,0,0.22)'; }}
            onMouseLeave={e => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = 'none'; }}
          >
            {/* Geometric accent per card */}
            <div style={{ position: 'absolute', top: '-15px', right: '-15px', width: '70px', height: '70px', border: '1px solid rgba(0,79,152,0.08)', borderRadius: '2px', transform: 'rotate(15deg)', pointerEvents: 'none' }} />

            {isCurrent && (
              <div
                className="absolute -top-3 left-4 px-3 py-1 rounded border-2"
                style={{ borderColor: 'var(--color-primary)', background: 'var(--color-card)' }}
              >
                <span className="text-xs font-medium" style={{ color: 'var(--color-primary)' }}>Nåværende plan</span>
              </div>
            )}
            {plan?.isPopular && !isCurrent && (
              <div
                className="absolute -top-3 left-4 px-3 py-1 rounded border-2"
                style={{ borderColor: 'var(--color-accent)', background: 'var(--color-card)' }}
              >
                <span className="text-xs font-medium" style={{ color: 'var(--color-accent)' }}>Mest populær</span>
              </div>
            )}

            <div className="mb-6">
              <h3 className="text-xl md:text-2xl font-semibold text-foreground mb-2">{plan?.name}</h3>
              <p className="text-sm md:text-base text-muted-foreground font-caption">{plan?.description}</p>
            </div>

            <div className="mb-6">
              <div className="flex items-baseline gap-2">
                <span className="text-3xl md:text-4xl font-semibold text-foreground">{plan?.price}</span>
                {plan?.tier > 0 && <span className="text-sm md:text-base text-muted-foreground">/ måned</span>}
              </div>
              {plan?.annualPrice && (
                <p className="text-xs md:text-sm text-muted-foreground mt-2 font-caption">
                  eller {plan?.annualPrice} / år (spar {plan?.savings})
                </p>
              )}
            </div>

            <div className="space-y-3 mb-6">
              {plan?.features?.map((feature, index) => (
                <div key={index} className="flex items-start gap-3">
                  <Icon name="Check" size={18} color="var(--color-success)" className="flex-shrink-0 mt-1" />
                  <span className="text-sm md:text-base text-foreground">{feature}</span>
                </div>
              ))}
            </div>

            {!isCurrent && isUpgrade && (
              <button
                onClick={() => onUpgrade(plan?.id)}
                style={{
                  width: '100%',
                  background: 'var(--color-accent)',
                  border: '2px solid var(--color-accent)',
                  borderRadius: 'var(--radius-sm)',
                  padding: '12px 24px',
                  fontFamily: 'var(--font-heading)',
                  fontSize: '14px',
                  fontWeight: 700,
                  letterSpacing: '0.06em',
                  textTransform: 'uppercase',
                  color: '#FFFFFF',
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '8px',
                  transition: 'all 250ms ease-out',
                }}
                onMouseEnter={e => e.currentTarget.style.background = '#E64A19'}
                onMouseLeave={e => e.currentTarget.style.background = 'var(--color-accent)'}
              >
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                  <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
                </svg>
                Oppgrader — Betal med faktura
              </button>
            )}

            {!isCurrent && !isUpgrade && (
              <Button variant="outline" size="default" fullWidth onClick={() => onUpgrade(plan?.id)}>
                Velg denne planen
              </Button>
            )}

            {isCurrent && (
              <Button variant="outline" size="default" fullWidth disabled>
                Din nåværende plan
              </Button>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default SubscriptionPlans;